import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card';
import color from '../../../config/colors.json';
import * as Style from './style';
import FunnelChart from '../Charts/Widgets/FunnelChart';
import SectionTitle from '../SectionTitle';

const Leads = ({
	title,
	subtitle,
	number,
	numberTwo,
	numberThree,
	numberFour,
	numberFive,
	text,
	textTwo,
	textThree,
	textFour,
	textFive,
	textData,
	percentage,
	textTitle,
}) => (
	<Card padding="20px 14px 13px 20px" border={`1px solid ${color.lightGrey43}`} noShadow>
		<SectionTitle
			title={title}
			subtitle={subtitle}
			titleHeight="20px"
			titleSize="14px"
			titleMarginBottom="0"
			subtitleHeight="20px"
			subtitleSize="14px"
			subtitleMarginBottom="0"
			marginBottom="33px"
			subtitleColor={color.dark2}
		/>
		<FunnelChart
			number={number}
			numberTwo={numberTwo}
			numberThree={numberThree}
			numberFour={numberFour}
			numberFive={numberFive}
			text={text}
			textTwo={textTwo}
			textThree={textThree}
			textFour={textFour}
			textFive={textFive}
			percentage={percentage}
			textTitle={textTitle}
		/>
		<Style.LastDataDate>
			<em>{textData}</em>
		</Style.LastDataDate>
	</Card>
);

Leads.defaultProps = {
	number: 1000,
	numberTwo: 800,
	numberThree: 400,
	numberFour: 380,
	numberFive: 100,
	percentage: '8,8%',
	textData: 'Dados dos últimos 30 dias*',
	subtitle: '',
};
Leads.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	number: PropTypes.number,
	numberTwo: PropTypes.number,
	numberThree: PropTypes.number,
	numberFour: PropTypes.number,
	numberFive: PropTypes.string,
	textData: PropTypes.string,
	percentage: PropTypes.string,
};

export default Leads;
